import {
  OrganizationInfo,
  OrganizationMember,
  OrganizationServiceAccountSummary,
} from '../types';
import apiRequest from './apiRequest';

export default async function getOrganization(organizationID: string) {
  return apiRequest<{
    organizationInfo: OrganizationInfo;
    members: OrganizationMember[];
    serviceAccounts: OrganizationServiceAccountSummary[];
  }>('user', `/organization/${organizationID}`);
}
